<template>
  <div class="proposal" :loading="isProposalLoading">
    <r-main-panel :title="`${$t('proposal.title')}`" icon="proposal">
      <proposal-list :proposal-list="proposalData" :is-loading="isLoading" />
    </r-main-panel>
    <div class="proposal__content">
      <proposal-user-info v-if="activeProposal" :proposal="activeProposal" />
      <proposal-bg v-else />
    </div>
  </div>
</template>

<script>
import proposalList from "./components/proposal-list/proposal-list";
import proposalUserInfo from "./components/proposal-user-info/proposal-user-info";
import proposalBg from "./components/proposal-bg/proposal-bg";

export default {
  components: { proposalList, proposalUserInfo, proposalBg },
  data() {
    return {
      isLoading: false,
      proposalData: []
    };
  },
  watch: {
    updateHandler: {
      handler: function(val) {
        if (!val) return;
        this.getProposals();
        this.$store.commit("SET_PROPOSAL_UPDATE", false);
      }
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.admin;
    },
    activeProposal() {
      const activeId = this.$route.query.id;
      if (!activeId) return null;
      const activeProposal = this.proposalData.find(e => e.id === activeId);

      return activeProposal;
    },
    updateHandler() {
      return this.$store.state.proposal.update;
    },
    isProposalLoading() {
      return this.$store.state.proposal.isLoading;
    }
  },
  methods: {
    async getProposals() {
      this.isLoading = true;

      try {
        const { data } = await this.$store.dispatch("REQUEST", {
          url: "proposal"
        });
        this.proposalData = data;
        this.isLoading = false;
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    }
  },
  created() {
    if (!this.isAdmin) {
      this.$router.push({ path: "/app/*" });
      return;
    }
    this.getProposals();
  }
};
</script>

<style lang="scss" scoped>
.proposal {
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: var(--table_cell_bg) !important;
  color: var(--text_secondary) !important;
  &__content {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
  }
}
</style>

<i18n>
{
  "ru": {
    "proposal": {
      "title": "Заявки на демо-доступ"
    }
  },
  "en": {
    "proposal": {
      "title": "Demo-access proposals"
    }
  }
}
</i18n>
